import React from "react";
import { useTranslation } from "react-i18next";
import { cn } from "@/lib/utils";

/**
 * Accessible SkipLink navigation element (WCAG 2.1 SC 2.4.1 Bypass Blocks).
 * Visually hidden until keyboard focus, jumps user directly to the primary main content.
 */
export function SkipLink({ targetId = "main-content", className = "" }) {
  const { t } = useTranslation("common");
  return (
    <a
      href={`#${targetId}`}
      className={cn(
        "sr-only focus:not-sr-only focus:fixed focus:top-4 focus:left-4 focus:z-[100] focus:px-4 focus:py-2 focus:bg-primary focus:text-primary-foreground focus:rounded-md focus:shadow-lg focus:outline-none focus:ring-2 focus:ring-ring font-medium text-sm transition-transform",
        className
      )}
    >
      {t("a11y.skipToContent", "Skip to main content")}
    </a>
  );
}

export default SkipLink;
